  <div class="tw-p-3">
    <!-- BORROWER SEARCH MENU -->
    <button
      mat-flat-button
      [matMenuTriggerFor]="borrowerSearch"
      [style.position]="'absolute'"
      [style.left.px]="menuX"
      [style.top.px]="menuY"
      #borrowerSearchTrigger="matMenuTrigger">
    </button>
    <mat-menu #borrowerSearch="matMenu" class="borrower-search-menu">
      <div class="borrower-search-header">
        Which business is this event for?
      </div>
      <div class="borrower-search-input">
        <app-borrower-search-input (borrower)="openCreateEvent($event)"></app-borrower-search-input>
      </div>
    </mat-menu>
    <!-- CREATE NEW EVENT MENU -->
    <button
      mat-flat-button
      [matMenuTriggerFor]="newEvent"
      [style.position]="'absolute'"
      [style.left.px]="menuX"
      [style.top.px]="menuY"
      #newEventTrigger="matMenuTrigger"
      (menuClosed)="clearBorrowerAndEventDate()">
    </button>
    <mat-menu #newEvent="matMenu" class="new-event-menu">
      <h3 *ngIf="borrower" class="borrower-name">{{ borrower.name }}</h3>
      <app-schedule-reminder-form
        *ngIf="borrower"
        [startDate]="eventDate"
        (newReminder)="createNewEvent($event)"
        (cancel)="closeReminderForm()">
      </app-schedule-reminder-form>
    </mat-menu>
    <!-- RESCHEDULE EVENT MENU -->
    <button
      mat-flat-button
      [matMenuTriggerFor]="rescheduleEvent"
      [style.position]="'absolute'"
      [style.left.px]="menuX"
      [style.top.px]="menuY"
      #rescheduleEventTrigger="matMenuTrigger">
    </button>
    <mat-menu #rescheduleEvent="matMenu" class="reschedule-event-menu">
      <h3 *ngIf="selectedReminder && selectedReminder.borrower" class="borrower-name">{{ selectedReminder.borrower.name }}</h3>
      <app-schedule-reminder-form
        *ngIf="selectedReminder"
        [startDate]="selectedReminder.expires"
        [reminder]="selectedReminder"
        (rescheduleReminder)="rescheduleReminder($event)"
        (cancel)="closeReminderForm()">
      </app-schedule-reminder-form>
    </mat-menu>
    <!-- VIEW/EDIT/DELETE/COMPLETE EXISTING EVENT MENU -->
    <button
      mat-flat-button
      [matMenuTriggerFor]="selectedEvent"
      [style.position]="'absolute'"
      [style.left.px]="menuX"
      [style.top.px]="menuY"
      #selectedEventTrigger="matMenuTrigger">
    </button>
    <mat-menu #selectedEvent="matMenu" class="selected-event-menu">
      <div *ngIf="selectedReminder">
        <h3 class="borrower-name">
          <a *ngIf="selectedReminder.borrower" [routerLink]="['/borrower/' + selectedReminder.borrower.id]">
            <span class="borrower-name-text">{{ selectedReminder.borrower.name }}</span>
            <span *ngIf="selectedReminder.action === 'call'" class="icon-padding fa fa-phone"></span>
            <span *ngIf="selectedReminder.action === 'todo'" class="icon-padding fa fa-th-list"></span>
            <span *ngIf="selectedReminder.action === 'message'" class="icon-padding fa fa-comment"></span>
          </a>
        </h3>
        <span class="reminder-time">
          {{ selectedReminder.action.charAt(0).toUpperCase() + selectedReminder.action.slice(1) }}: {{ reminderTime(selectedReminder.expires) }}
        </span>
        <p *ngIf="selectedReminder.reason !== ''" class="reminder-reason">{{ selectedReminder.reason }}</p>
        <div class="reminder-action-buttons">
          <div *ngIf="selectedEventInFuture; else overdueEvent">
            <button
              class="reschedule-btn"
              mat-button
              (click)="openReschedule()"
              matTooltip="Edit or reschedule reminder"
              data-cy="reschedule-btn">
              <mat-icon>create</mat-icon>
            </button>
            <button
              class="cancel-btn"
              mat-button
              (click)="cancelReminder()"
              matTooltip="Cancel reminder"
              data-cy="cancel-reminder-btn">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
          <ng-template #overdueEvent>
            <div *ngIf="!selectedReminder.occurred; else reminderCompleted">
              <span [ngSwitch]="selectedReminder.action">
                <button
                  *ngSwitchCase="'call'"
                  class="call-btn"
                  mat-button
                  (click)="callBorrower()"
                  matTooltip="Call merchant">
                  <mat-icon>call</mat-icon>
                </button>
                <button
                  *ngSwitchCase="'message'"
                  class="message-btn"
                  mat-button
                  (click)="messageBorrower()"
                  matTooltip="Message merchant">
                  <mat-icon>textsms</mat-icon>
                </button>
                <button
                  *ngSwitchDefault
                  class="view-btn"
                  mat-button
                  (click)="viewBorrower()"
                  matTooltip="View merchant page">
                  <mat-icon>visibility</mat-icon>
                </button>
              </span>
              <button
                class="reschedule-btn"
                mat-button
                (click)="openReschedule()"
                matTooltip="Edit or reschedule reminder"
                data-cy="reschedule-btn">
                <mat-icon>create</mat-icon>
              </button>
              <button
                class="complete-btn"
                mat-button
                (click)="completeReminder()"
                matTooltip="Mark as completed">
                <mat-icon>check_circle</mat-icon>
              </button>
              <button
                class="cancel-btn"
                mat-button
                (click)="cancelReminder()"
                matTooltip="Cancel reminder"
                data-cy="cancel-reminder-btn">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
            <ng-template #reminderCompleted>
              <span class="reminder-completed">
                <span class="green-check fa fa-check"></span> Reminder Completed
              </span>
            </ng-template>
          </ng-template>
        </div>
      </div>
    </mat-menu>
    <!-- CALENDAR ALERTS -->
    <mat-grid-list *ngIf="alerts.length > 0" cols="1" rowHeight="60px">
      <mat-grid-tile>
        <div class="alerts-container">
          <app-alert
            *ngFor="let alert of alerts"
            [message]="alert.message"
            [level]="alert.level"
            [dismissDelay]="alert.dismissDelay"
            (dismissed)="dismissAlert(alert)">
          </app-alert>
        </div>
      </mat-grid-tile>
    </mat-grid-list>
    <!-- MAIN CALENDAR VIEW -->
    <mat-grid-list cols="3" rowHeight="50px" class="calendar-header">
      <mat-grid-tile [colspan]="1">
        <div class="calendar-nav">
          <div class="btn-group">
            <button
              class="mat-elevation-z0 cal-nav-btn"
              mat-mini-fab
              mwlCalendarPreviousView
              [view]="view"
              [(viewDate)]="viewDate"
              (viewDateChange)="closeOpenMonthViewDay()">
              <mat-icon>navigate_before</mat-icon>
            </button>
            <button
              class="tw-ml-2"
              mat-flat-button
              mwlCalendarToday
              [(viewDate)]="viewDate">
              Today
            </button>
            <button
              class="tw-ml-2"
              mat-mini-fab
              mwlCalendarNextView
              [view]="view"
              [(viewDate)]="viewDate"
              (viewDateChange)="closeOpenMonthViewDay()">
              <mat-icon>navigate_next</mat-icon>
            </button>
          </div>
        </div>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="1">
        <h2 *ngIf="view === CalendarView.Month || view === CalendarView.Week">{{ viewDate | date:'MMMM y' }}</h2>
        <h2 *ngIf="view === CalendarView.Day">{{ viewDate | date:'longDate' }}</h2>
      </mat-grid-tile>
      <mat-grid-tile [colspan]="1">
        <div class="calendar-views">
          <div class="btn-group">
            <button
              class="cal-view-btn cal-view-day"
              color="primary"
              mat-flat-button
              (click)="setView(CalendarView.Day)"
              [class.active]="view === CalendarView.Day"
              data-cy="day-btn">
              Day
            </button>
            <button
              data-cy="week-btn"
              class="cal-view-btn cal-view-week"
              color="primary"
              mat-flat-button
              (click)="setView(CalendarView.Week)"
              [class.active]="view === CalendarView.Week">
              Week
            </button>
            <button
              data-cy="month-btn"
              class="cal-view-btn cal-view-month"
              color="primary"
              mat-flat-button
              (click)="setView(CalendarView.Month)"
              [class.active]="view === CalendarView.Month">
              Month
            </button>
          </div>
        </div>
      </mat-grid-tile>
    </mat-grid-list>
    <!-- ANGULAR-CALENDAR TOGGLE-ABLE VIEW TYPES -->
    <div [ngSwitch]="view">
      <mwl-calendar-month-view
        *ngSwitchCase="'month'"
        [viewDate]="viewDate"
        [events]="events"
        [activeDayIsOpen]="activeDayIsOpen"
        [refresh]="refresh"
        (dayClicked)="dayClicked($event.day)"
        (eventTimesChanged)="eventTimesChanged($event)"
        (eventClicked)="eventClicked($event)">
      </mwl-calendar-month-view>
      <mwl-calendar-week-view
        *ngSwitchCase="'week'"
        [viewDate]="viewDate"
        [events]="events"
        [refresh]="refresh"
        [dayStartHour]="6"
        [dayEndHour]="21"
        (eventTimesChanged)="eventTimesChanged($event)"
        (hourSegmentClicked)="openBorrowerSearch($event)"
        (eventClicked)="eventClicked($event)">
      </mwl-calendar-week-view>
      <mwl-calendar-day-view
        *ngSwitchCase="'day'"
        [viewDate]="viewDate"
        [events]="events"
        [refresh]="refresh"
        [dayStartHour]="6"
        [dayEndHour]="21"
        (eventTimesChanged)="eventTimesChanged($event)"
        (hourSegmentClicked)="openBorrowerSearch($event)"
        (eventClicked)="eventClicked($event)">
      </mwl-calendar-day-view>
    </div>
    <!-- COLOR KEY/LEGEND -->
    <mat-grid-list cols="1" rowHeight="60px" class="cal-color-legend">
      <mat-grid-tile>
        <span class="yellow-circle"></span> overdue
        <span class="blue-circle"></span> upcoming
        <span class="green-circle"></span> completed
      </mat-grid-tile>
    </mat-grid-list>
  </div>
